import {Stack, Tooltip, Typography} from '@mui/material';
import DriveFileRenameOutlineRoundedIcon from '@mui/icons-material/DriveFileRenameOutlineRounded';
import {useTranslation} from 'react-i18next';

export interface FishGroupRowProps {
  label: string;
  icon?: JSX.Element;
  value: string;
  options?: string[];
  nameIsCustom?: boolean;
}

export const FishGroupRow = ({label, icon, value, options, nameIsCustom}: FishGroupRowProps): JSX.Element => {
  const {t} = useTranslation('common');
  const isMixed: boolean = !!(options && options.length > 1);

  return (
    <Stack direction={'row'} alignItems={'center'}>
      <Stack direction={'row'} width={90} alignItems={'center'} spacing={0.5}>
        <Typography variant="body2" color={'secondary'}>
          {label}
        </Typography>
        {nameIsCustom && (
          <Tooltip title={t('isEdited')}>
            <DriveFileRenameOutlineRoundedIcon fontSize={'inherit'} color="primary" />
          </Tooltip>
        )}
      </Stack>
      <Stack direction={'row'} alignItems={'center'} spacing={1}>
        {icon}
        <Typography variant="body2">{isMixed ? t('mixed') : value}</Typography>
      </Stack>
    </Stack>
  );
};
